import {
  type ContactConsentChannel,
  setContactConsentRequestBase,
} from '@borradh-workspace/contracts';

/** What the Consent tab knows: the box that changed and the version it showed. */
export interface SetContactConsentInput {
  channel: ContactConsentChannel;
  enabled: boolean;
  expectedVersion: string;
}

export function buildSetContactConsentPayload(input: SetContactConsentInput) {
  return setContactConsentRequestBase.parse(input);
}
